import styled from "styled-components";
import FooterBg from "../../assets/images/FooterPattern.png";
import yellowTitleBg from "../../assets/images/yellowTitleBg.svg";

export const Footer = styled.footer`
  display: flex;
  flex-direction: column;
  background: url(${FooterBg}) no-repeat 35% 0%;
`;

export const FooterContainer = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* width: 100%; */
  @media (max-width: 1280px) {
    justify-content: center;
    margin-bottom: 2rem;
    padding: 0 2rem;
    text-align: center;
  }
  @media (max-width: 760px) {
    padding: 0 ${(props) => props.noBreak || "24rem"} !important;
  }
`;

export const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
  /* height: 200px; */
  @media (max-width: 1280px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;
export const FooterLogo = styled.div`
  margin-bottom: 1rem;
  img {
    width: 100px;
    height: 100px;
    display: block;
  }
`;
export const FooterLicenseContainer = styled.section`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  a {
    display: inline-block;
  }
`;

export const LinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 170px;
  h3 {
    color: #6bd7dd;
    font-size: 1.8rem;
    font-weight: 80rem;
    margin-bottom: 3rem;
    background: url(${yellowTitleBg}) no-repeat 100% 50%;
  }
  @media (max-width: 1280px) {
    display: none;
  }
`;

export const FooterLinks = styled.ul`
  display: flex;
  flex-direction: column;
  padding-right: 1rem;
  a {
    color: var(--text-color);
  }
  li {
    font-size: 1.6rem;
    font-weight: 5rem;
    color: var(--text-color);
    margin-bottom: 0.5rem;
  }
`;

export const FooterContact = styled.ul`
  /* display: flex;
  flex-direction: column;
  align-items: center; */
  height: 170px;
  & li {
    font-size: 14px;
    font-weight: 500;
    color: var(--title-color);
  }
  h3 {
    color: #6bd7dd;
    font-size: 1.8rem;
    font-weight: 80rem;
    margin-bottom: 3rem;
    background: url(${yellowTitleBg}) no-repeat 100% 50%;
  }
  ul {
    display: flex;
    margin-top: 1rem;
    li {
      font-size: 14px;
      font-weight: 500;
    }
    li a {
      cursor: pointer;
    }
  }
  @media (max-width: 1280px) {
    display: none;
  }
`;

export const AddressContainer = styled.address`
  color: var(--title-color);
  font-size: 1.4rem;
  font-weight: 50rem;
  /* padding-right: 1rem; */
  width: 240px;
`;

export const FooterBottom = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 4rem 0;
  font-size: 1.4rem;
  color: var(--title-color);
  font-weight: 50rem;
  a {
    color: var(--primary-color);
    &:focus,
    &:active {
      color: unset;
    }
  }
  @media (max-width: 760px) {
    text-align: center;
    margin-top: 3.5rem;
  }
`;
